"use client";
import {JSX} from "react";

import {useTranslation} from "@/shared/i18n/use-translation";
import {Typography} from "@/shared/ui/data-display/typography/typography";
import {ContainerBase} from "@/shared/ui/layout/container-base";

import "./footer-simple.scss";

export function FooterSimple(): JSX.Element {
    const {t} = useTranslation("footer");
    const year = new Date().getFullYear();

    return (
        <footer className="footer-simple">
            <ContainerBase>
                <div className="footer-simple__content">
                    <div className="footer-simple__left">
                        <Typography as="p" size={{desktop: 14, mobile: 12}} weight={400} color="paragraph2">
                            {t("copyrightSimple", {year})}
                        </Typography>
                    </div>
                </div>
            </ContainerBase>
        </footer>
    );
}
